import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { SlideDown } from 'react-slidedown';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Requester } from 'models/travelDetails';
import { formatISODateToDDMMYYYY } from 'utils/generic';

import { Container, Info, SeeMore, Subtitle, Content } from './styles';

interface Props {
  requester: Requester;
  confirmationCode: string;
}

const GuestCard = ({ requester, confirmationCode }: Props) => {
  const { t } = useStoreTranslation();
  const [show, setShow] = useState(false);

  const toggleSeeMore = () => {
    setShow(!show);
  };

  return (
    <Container>
      <SeeMore onClick={toggleSeeMore}>
        <Subtitle>{t('guestCard.title')}</Subtitle>
        {show ? <MdKeyboardArrowUp size={26} /> : <MdKeyboardArrowDown size={26} />}
      </SeeMore>
      <SlideDown closed={!show}>
        <Content>
          <Subtitle>{t('guestCard.guestNumber', { count: 1 })}</Subtitle>
          <Info>
            <Info.Title>{t('guestCard.name')}</Info.Title>
            <Info.Content>{requester.fullName}</Info.Content>
          </Info>
          <Info>
            <Info.Title>{t('guestCard.document')}</Info.Title>
            <Info.Content>{requester.documentNumber}</Info.Content>
          </Info>
          <Info>
            <Info.Title>{t('guestCard.birthDate')}</Info.Title>
            <Info.Content>{formatISODateToDDMMYYYY(requester.birthDate)}</Info.Content>
          </Info>
          {requester.phoneNumber && (
            <Info>
              <Info.Title>{t('guestCard.phoneNumber')}</Info.Title>
              <Info.Content>{requester.phoneNumber}</Info.Content>
            </Info>
          )}
          {requester.email && (
            <Info>
              <Info.Title>{t('guestCard.email')}</Info.Title>
              <Info.Content>{requester.email}</Info.Content>
            </Info>
          )}
          <Info>
            <Info.Title>{t('guestCard.confirmationCode')}</Info.Title>
            <Info.Content>{confirmationCode}</Info.Content>
          </Info>
        </Content>
      </SlideDown>
    </Container>
  );
};

export default GuestCard;
